/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipient_AiInputs */

const da_privacy_recipient_ai = /** @type {(inputs: Privacy_Recipient_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-sprogmodeller, kun ved rettelser og de AI-hjælpere, du selv beder om.`)
};

/** @type {(inputs: Privacy_Recipient_AiInputs) => LocalizedString} */
const en_privacy_recipient_ai = da_privacy_recipient_ai;

/**

* @param {Privacy_Recipient_AiInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipient_ai = /** @type {((inputs?: Privacy_Recipient_AiInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipient_AiInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipient_ai(inputs)
	return /** @type {LocalizedString} */ ("AI-sprogmodeller, kun ved rettelser og de AI-hjælpere, du selv beder om.")
});